import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import accountCheck from "@iconify/icons-mdi/account-check";
import { Icon } from "@iconify/react";
import OcCard from "oc/components/card/card";

interface MyTimeExaminersCardProps {
  data?: string[];
  loading?: boolean;
  error?: React.ReactNode;
}

export const MyTimeExaminersCard: React.FC<MyTimeExaminersCardProps> = ({
  data,
  loading,
  error,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  if (data?.length === 0 && !loading) {
    return (
      <OcCard label={t("OC_EXAMINERS")} loading={loading} error={!!error}>
        <Box style={{ color: theme.palette.primary.main, padding: "16px 0px" }}>
          {t("OC_MISSING_EXAMINERS")}
        </Box>
      </OcCard>
    );
  }

  return (
    <OcCard label={t("OC_EXAMINERS")} loading={loading} error={!!error}>
      <Box>
        {data?.map((item, index) => {
          return (
            <Box
              key={`my-time-examiners-${index}`}
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Icon icon={accountCheck} height="24px" />
              <Box width="10px" />
              <Box paddingBottom="4px">{item}</Box>
            </Box>
          );
        })}
      </Box>
    </OcCard>
  );
};

export default MyTimeExaminersCard;
